import { NAV_PATHS } from '@modules/common/constants';
import { useIsSearchToFeedEnabled } from '@modules/common/hooks';
import { DateRangeField } from '@modules/feed/components/SearchAnalysesToolbar/DateRangeField';
import { SearchTitle } from '@modules/feed/components/SearchTitle';
import { SearchActionType } from '@modules/feed/store/searchActionType';
import { useSearchStore } from '@modules/feed/store/searchStore';
import ArrowBackRoundedIcon from '@mui/icons-material/ArrowBackRounded';
import { IconButton } from '@mui/material';
import { useCallback, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';

export const useGetSearchLeftActions = () => {
  const navigate = useNavigate();

  const dispatch = useSearchStore(({ dispatch }) => dispatch);

  const isSearchToFeedEnabled = useIsSearchToFeedEnabled();

  const onBackClick = useCallback(() => {
    navigate(`/${isSearchToFeedEnabled ? NAV_PATHS.FEED : NAV_PATHS.SEARCH}`);
    dispatch({
      type: SearchActionType.RESET,
    });
  }, [dispatch, isSearchToFeedEnabled, navigate]);

  const leftActions = useMemo(
    () => [
      {
        component: !isSearchToFeedEnabled ? (
          <IconButton size="small" onClick={onBackClick}>
            <ArrowBackRoundedIcon />
          </IconButton>
        ) : null,
        key: 'Back Button',
      },
      {
        component: <SearchTitle />,
        key: 'Search Title',
      },
      {
        component: <DateRangeField />,
        key: 'Date Picker',
      },
    ],
    [isSearchToFeedEnabled, onBackClick],
  );

  return leftActions;
};
